module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-date-8865c593.svg";